// Per-environment settings, fetched at startup from /config.json so the same
// static build runs against dev or prod. Nothing here is secret: the app runs in
// a browser, so its users can see all of it.

export type AppConfig = {
  apiUrl: string;
  cognitoRegion: string;
  cognitoClientId: string;
  // Where a new tenant's admin signs in, to tell them.
  staffAppUrl: string;
};

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error("config.json is missing");
  const raw = (await res.json()) as Partial<AppConfig>;
  for (const key of ["apiUrl", "cognitoRegion", "cognitoClientId", "staffAppUrl"] as const) {
    if (typeof raw[key] !== "string" || !raw[key]) throw new Error(`config.json has no ${key}`);
  }
  return { ...(raw as AppConfig), apiUrl: (raw.apiUrl as string).replace(/\/$/, "") };
}
